import { createSelector } from 'reselect';

const getFateCards = ({ fate: { data: { fateCards } } }) => fateCards;

const inputFuncs = state => getFateCards(state);

const outputFunc = fateCards => [...new Set(fateCards.map(({ id }) => id))]
  .map(id => fateCards.find(card => id === card.id))
  .filter(item => !item.hidden);


export default createSelector(inputFuncs, outputFunc);